import template from 'text!./templates/gw-carousel.html';

export default [function () {
    return {
        'restrict': 'AE',
        'template': template,
        'transclude': true,
        'replace': true,
        'scope': {
            'interval': '=?',
            'wrapSlides': '=?'
        },
        'controller': ['$scope', '$element', '$transclude', function ($scope) {
            $scope.interval = $scope.interval || 5000;
            $scope.wrapSlides = $scope.wrapSlides || true;
            $scope.activeFn = function () {}; // Used to invoke child active slide function.
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/carousel/directives/GwCarousel.js
// module id = 1096
// module chunks = 0